<div [hidden]="consulta">
  <div class="row">
      <div class="col-lg-12" style="padding: 0px;">
          <section class="widget">
              <!-- título -->
              <header>
                  <h3> {{sistemaService.NombrePantallaActual}}: {{accion.accion}}</h3>
              </header>
          </section>
          <div class="divisor8"></div>
          <section class="widget">
              <div class="row" style="margin-bottom: 15px;">
                  <div class="col-lg-8 col-md-12 col-sm-12 col-12">
                      <div class="row margen">
                        <div class="col-lg-2 col-md-6 col-sm-12 col-12">
                          <inputCustom [titulo]="'Ciclo'"
                          [(ngModel)]="entidad.ciclo"
                          [disabled]="true"></inputCustom>
                      </div>
                      <div class="col-lg-5 col-md-6 col-sm-12 col-12">
                        <inputCustom [titulo]="'Periodo de evaluación'"
                        [(ngModel)]="entidad.periodoevaluacion"
                        [disabled]="true"></inputCustom>
                    </div>
                          <div class="col-lg-5 col-md-6 col-sm-12 col-12">
                              <inputCustom [titulo]="'Persona evaluada'"
                              [(ngModel)]="entidad.nombresubordinado"
                              [disabled]="true"></inputCustom>
                          </div>
                          <div class="col-lg-2 col-md-6 col-sm-12 col-12" *ngIf="!vergrupo">
                            <inputCustom [titulo]="'Nivel'"
                            [(ngModel)]="entidad.nivel"
                            [disabled]="true"></inputCustom>
                        </div>
                        <div class="col-lg-2 col-md-6 col-sm-12 col-12" *ngIf="vergrupo">
                          <span>Niveles</span>
                          <br>
                          <br>
                          <textareaCustom [disabled]="true" [titulo]="'Nivel'" [innerHTML]="nivelagrupado"></textareaCustom>
                        </div>
                          <div class="col-lg-5 col-md-6 col-sm-12 col-12" *ngIf="!vergrupo">
                              <inputCustom [titulo]="'Puesto'"
                              [(ngModel)]="entidad.puestosub"
                              [disabled]="true"></inputCustom>
                          </div>
                          <div class="col-lg-5 col-md-6 col-sm-12 col-12" *ngIf="vergrupo">
                            <span>Puestos</span>
                            <br>
                            <br>
                            <textareaCustom [disabled]="true" [innerHTML]="puestoagrupado"></textareaCustom>
                          </div>
                          <div class="col-lg-5 col-md-6 col-sm-12 col-12" *ngIf="!vergrupo">
                              <inputCustom [titulo]="'Departamento'"
                              [(ngModel)]="entidad.departamentosub"
                              [disabled]="true"></inputCustom>
                          </div>
                          <div class="col-lg-5 col-md-6 col-sm-12 col-12" *ngIf="vergrupo">
                            <span>Departamentos</span>
                            <br>
                            <br>
                            <textareaCustom [titulo]="'Departamento'" [innerHTML]="departamentoagrupado" [disabled]="true"></textareaCustom>
                          </div>
                      </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                      <div class="base">
                          <div class="esqueletoboton">
                              <button class="boton botonSM filledBlanco margenboton" (click)="Generarpdf()">Generar PDF</button>
                          </div>
                          <div class="margenimagen" *ngIf="entidad.urlfotografia">
                              <div class="imagencolaborador">
                                  <imagenVisualizador [imagen]="entidad.urlfotografia"  [verCompleta]="false" [alineacion]="AlineacionImagenEnum.ScaleAspectToFit"></imagenVisualizador>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-12" *ngIf="vergrupo" style="margin-top: 15px;">
                    <button class="boton botonSM filledBlanco botonfooter" (click)="ModalInternotabla()">Ver detalle de acuerdo agrupado</button>
                  </div>
              </div>

              <dx-tab-panel #tab  [animationEnabled]="true" (onTitleClick)="yourFn()" style="max-height: 39rem;" [(selectedIndex)]="selectedTabIndex">
                <dxi-item title="Acuerdo" >
                    <consultaacuerdo_acuerdo #acuerdo
                    [entidad]="entidad"
                    [accion]="accion"
                    >
                    </consultaacuerdo_acuerdo>
                </dxi-item>
                <dxi-item title="General">
                  <consultaacuerdo_general #general
                  [entidad]="entidad"
                  [accion]="accion">

                  </consultaacuerdo_general>
                </dxi-item>
                <dxi-item title="Alumno">
                  <consultaacuerdo_alumno #alumno
                  [entidad]="entidad"
                  [accion]="accion">

                  </consultaacuerdo_alumno>
                </dxi-item>
                <dxi-item title="Padre de familia">
                  <consultaacuerdo_padre #padre
                  [entidad]="entidad"
                  [accion]="accion">

                  </consultaacuerdo_padre>
                </dxi-item>
                <dxi-item title="Alumnos - Talleres extracurriculares">
                  <div></div>
                  <consultaacuerdo_alumnotaller  #alumnotaller
                  [entidad]="entidad"
                  [accion]="accion"
                  >
                  </consultaacuerdo_alumnotaller>
                </dxi-item>
                <dxi-item title="Padres de familia - Talleres extracurriculares">
                  <div></div>
                  <consultaacuerdo_padretaller  #padretaller
                  [entidad]="entidad"
                  [accion]="accion"
                  >
                  </consultaacuerdo_padretaller>
                </dxi-item>
            </dx-tab-panel>

              <div class="divisor20"></div>
              <div class="row margen" >
                  <div class="col-12">
                      <div class="panelBotonesFiltro">
                          <button class="boton botonSM filledBlanco"
                          (click)="Salir()">
                          <span> {{'Cerrar'}}</span>
                      </button>
                      </div>
                  </div>
              </div>
          </section>
      </div>
  </div>
</div>



<ng-container *ngIf="abierto2">
  <div class="backdrop"></div>
  <div class="modalPanelAdmin animated {{animacion}}">

      <div class="contenido">
         <!--  Título -->
          <div class="encabezadoModal">
              <div class="modalTituloSimple">
                  {{('Acuerdos agrupados')}}
              </div>
          </div>
          <div class="modalContenido">
             <!--  datos -->
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                    <inputCustom [titulo]="'Persona a evaluar'"
                        [(ngModel)]="entidad.nombresubordinado"
                        [disabled]="true"></inputCustom>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                  <inputCustom [titulo]="'Ciclo'"
                      [(ngModel)]="entidad.ciclo"
                      [disabled]="true"></inputCustom>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                <inputCustom [titulo]="'Periodo de evaluación'"
                    [(ngModel)]="entidad.periodoevaluacion"
                    [disabled]="true"></inputCustom>
            </div>
                </div>
              </div>
              <div class="col-12">
                <dx-data-grid
                (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                id="tabla"
                [columnAutoWidth]="true"
                [dataSource]="listapuestoacuerdo"
                [noDataText]="'Sin Datos'"
                [showColumnHeaders]="true"
                >
                <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" matTooltip="Todo" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                <dxo-search-panel
                    [visible]="true"
                    [width]="240"
                    placeholder="{{'Buscar' | translate}}">
                </dxo-search-panel>

                <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                <dxo-pager
                    [visible]="true"
                    [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                    [displayMode]="sistemaService.tablaPaginacionModo"
                    [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                    [showInfo]="sistemaService.tablaPaginacionInfo"
                    [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                </dxo-pager>
                <dxi-column
                    dataField="puestosub"
                    caption="Puesto">
                </dxi-column>
                <dxi-column
                    dataField="departamentosub"
                    caption="Departamento">
                </dxi-column>
                <dxi-column
                    dataField="materia"
                    caption="Materia o taller">
                </dxi-column>
                <dxi-column
                  dataField="nombrejefelista"
                  caption="Jefe">
                </dxi-column>
                <dxi-column
                    dataField="puestoje"
                    caption="Puesto del jefe">
                </dxi-column>
                <dxi-column
                  dataField="nombrejefe"
                  caption="Jefe responsable del acuerdo">
                </dxi-column>

            </dx-data-grid>
              </div>
            </div>
          </div>

         <!--  footer -->
          <div class="modalFooter">
                 <!--  editar -->
                  <div class="row">
                      <div class="col-6">
                        <button class="boton botonSM filledBlanco botonfooter" (click)="CerrarModalInternotabla()">
                          {{'Cancelar' | translate}}
                      </button>
                      </div>
                  </div>
          </div>
      </div>
  </div>
</ng-container>
